import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'orderUnitType'
})
export class OrderUnitTypePipe implements PipeTransform {

  transform(value: string, orderUnitTypeList: { value: string; label: string }[]): string {
    let label = String(value);

    for (const orderUnitType of orderUnitTypeList) {
      if (orderUnitType.value === value) {
        label = orderUnitType.label;
      }
    }

    return label;
  }

}
